import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=5491f05a&"
import script from "./ShoppingList.vue?vue&type=script&lang=ts&"
export * from "./ShoppingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports